const artistsDE = {
    "view": {
        "table": {
            "title": "Ihre Künstlerliste",
            "column": {
                "name": "Künstlername",
                "owner": "Besitzer",
                "spotify_link": "Spotify-Link",
                "apple_music_link": "Apple Music-Link",
                "amazon_music_link": "Amazon Music-Link",
                "deezer_link": "Deezer-Link",
                "flagged": "Markiert",
                "blacklisted": "Gesperrt",
                "action": "Aktion"
            },
            "button": {
                "export_csv": "CSV exportieren"
            },
            "placeholder": {
                "search": "Suchen..."
            },
            "message": {
                "artistFlagged": "Dieser Künstler ist markiert und eine Treuhandzahlung ist erforderlich, um die Veröffentlichung auf Spotify zu verteilen.",
                "artistNotFlagged": "Dieser Künstler ist für die Spotify-Verteilung berechtigt.",
                "artistBlacklisted": "Dieser Künstler ist gesperrt und nicht für die Verteilung berechtigt.",
                "artistNotBlacklisted": "Dieser Künstler ist nicht gesperrt und für die Verteilung berechtigt.",
            }
        },
        "message": {
            "success": "Künstler wurde entfernt!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "notSubscribed": "Sie sind bei keinem Plan abonniert, daher können Sie nur <strong>3 Künstler</strong> hinzufügen. Bitte <3>abonnieren</3> Sie einen Plan, um eine unbegrenzte Anzahl von Künstlern zu nutzen.",
            "subscriptionUpgrade": "Ihr aktueller Abonnementplan unterstützt diese Funktion nicht. Bitte <1>aktualisieren</1> Sie Ihren Abonnementplan, um diese Funktion zu nutzen.",
            "subscriptionExpired": "Ihr Abonnement ist abgelaufen. Bitte <1>setzen</1> Sie Ihr Abonnement fort, um diese Funktion zu nutzen.",
            "noAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen."
        },
        "modal": {
            "cantBeDeleted": {
                "header": "Künstler {{artistName}} kann nicht gelöscht werden",
                "body": "Künstler {{artistName}} kann nicht gelöscht werden, da bereits Track(s)/Veröffentlichung(en) mit ihm verbunden sind."
            },
            "delete": {
                "header": "{{artistName}} löschen?",
                "body": "Sind Sie sicher, dass Sie diesen Künstler wirklich löschen möchten? Diese Aktion könnte Ihren Künstler von der zugewiesenen Veröffentlichung trennen."
            },
            "edit": {
                "header": "{{artistName}} bearbeiten?",
                "body": "Sind Sie sicher, dass Sie den Namen Ihres Künstlers ändern möchten? Dies könnte Auswirkungen auf die Metadaten der Veröffentlichung haben."
            }
        }
    },
    "add": {
        "title": "Künstler hinzufügen",
        "form": {
            "label": {
                "is_new_artist": "Ist neuer Künstler",
                "spotify_profile": "Spotify-Profil",
                "deezer_profile": "Deezer-Profil",
                "amazon_music_profile": "Amazon Music-Profil",
                "spotify_image": "Spotify-Bild",
                "deezer_image": "Deezer-Bild",
                "amazon_music_image": "Amazon Music-Bild",
                "spotify_id": "Spotify-ID",
                "deezer_id": "Deezer-ID",
                "amazon_music_id": "Amazon Music-ID",
                "apple_id": "Apple-ID",
                "name": "Name",
                "name_preference": "Namenspräferenz",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "E-Mail",
                "subuser": "Sub-Benutzer"
            },
            "help_text": {
                "is_new_artist": "Fügen Sie einen neuen Künstler hinzu, d.h. Wenn Ihr Künstler Veröffentlichungen auf Spotify/Deezer/Amazon Music/Apple Music hat, wählen Sie Nein, andernfalls Ja.",
                "spotify_profile": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie einen Künstler hinzufügen möchten, der bereits auf Spotify ist, andernfalls klicken Sie auf die Schaltfläche Nicht gefunden.",
                "deezer_profile": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie einen Künstler hinzufügen möchten, der bereits auf Deezer ist, andernfalls klicken Sie auf die Schaltfläche Nicht gefunden.",
                "amazon_music_profile": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie einen Künstler hinzufügen möchten, der bereits auf Amazon Music ist, andernfalls klicken Sie auf die Schaltfläche Nicht gefunden.",
                "apple_id": "Hinweis: Verwenden Sie dieses Feld nur, wenn Sie einen Künstler hinzufügen möchten, der bereits auf Apple Music ist, andernfalls klicken Sie auf die Schaltfläche Nicht gefunden.",
                "subuser": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie einen Künstler für einen Ihrer Sub-Benutzer hinzufügen möchten, andernfalls lassen Sie es unselektiert."
            },
            "placeholder": {
                "subuser": "Sub-Benutzer auswählen...",
                "spotify_profile": "Geben Sie den Künstlernamen ein, z.B. The Weekend oder die Spotify-ID des Künstlers, z.B. 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Geben Sie den Künstlernamen ein, z.B. The Weekend oder die Deezer-ID des Künstlers, z.B. 1406580",
                "amazon_music_profile": "Geben Sie den Künstlernamen ein, z.B. The Weekend oder die Amazon ASIN des Künstlers, z.B. B005GI0T2U",
                "apple_id": "Bitte geben Sie eine gültige Apple-ID ein. Beispiel: 635806095"
            },
            "button": {
                "reset": "Zurücksetzen",
                "not_found": "Nicht gefunden",
                "submit": "Absenden"
            },
            "option": {
                "yes": "Ja",
                "no": "Nein"
            },
            "validation": {
                "name_required": "Name ist erforderlich",
                "name_invalid": "Der Künstlername muss 'DJ' nur in Großbuchstaben enthalten",
                "email_required": "E-Mail ist erforderlich",
                "email_invalid": "Bitte geben Sie eine gültige E-Mail ein",
                "name_duplicate": "Künstler existiert bereits",
                "name_mismatch": "Der Künstlername muss für alle Stores übereinstimmen",
                "spotify_id_invalid": "Bitte fügen Sie eine gültige Spotify-ID hinzu. Beispiel: 6eUKZXaKkcviH0Ku9w2n3B. Weitere Informationen finden Sie in unserem Help Center.",
                "apple_id_required": "Apple-ID ist erforderlich",
                "apple_id_invalid": "Bitte fügen Sie eine gültige Apple-ID hinzu. Beispiel: 635806095. Weitere Informationen finden Sie in unserem Help Center."
            }
        },
        "modal": {
            "title": {
                "new_artist_declaration": "Neue Künstlererklärung",
                "profile_not_present_declaration": "Profil nicht vorhanden Erklärung"
            },
            "body": {
                "profile_not_present_declaration": "Ich bestätige, dass das Profil dieses Künstlers auf <strong>{{store}}</strong> nicht vorhanden ist und dass das Profil dieses Künstlers neu auf <strong>{{store}}</strong> erstellt wird.",
                "new_artist_declaration": "Ich bestätige, dass das Profil dieses Künstlers in keinem der folgenden Stores vorhanden ist und dass das Profil dieses Künstlers neu in diesen Stores erstellt wird.",
                "new_artist_declaration_amazon_music": "Amazon Music",
                "new_artist_declaration_apple_music": "Apple Music",
                "new_artist_declaration_deezer": "Deezer",
                "new_artist_declaration_spotify": "Spotify"
            },
            "button": {
                "confirm": "Bestätigen",
                "cancel": "Abbrechen"
            }
        },
        "message": {
            "success": "Künstler wurde hinzugefügt!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "errorBlacklisted": "Eine oder mehrere der von Ihnen bereitgestellten Details sind mit einem gesperrten Künstler verbunden. Wenn Sie sicher sind, dass der Künstler nicht gesperrt ist, wenden Sie sich bitte an das Support-Team für weitere Informationen."
        }
    },
    "update": {
        "title": "Künstler bearbeiten",
        "form": {
            "label": {
                "spotify_profile": "Spotify-Profil",
                "deezer_profile": "Deezer-Profil",
                "amazon_music_profile": "Amazon Music-Profil",
                "spotify_image": "Spotify-Bild",
                "deezer_image": "Deezer-Bild",
                "amazon_music_image": "Amazon Music-Bild",
                "spotify_id": "Spotify-ID",
                "deezer_id": "Deezer-ID",
                "amazon_music_id": "Amazon Music-ID",
                "apple_id": "Apple-ID",
                "name": "Name",
                "name_preference": "Namenspräferenz",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "E-Mail",
                "flagged": "Markiert"
            },
            "help_text": {
                "spotify_profile": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie einen Künstler hinzufügen möchten, der bereits auf Spotify ist, andernfalls klicken Sie auf die Schaltfläche Nicht gefunden.",
                "deezer_profile": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie einen Künstler hinzufügen möchten, der bereits auf Deezer ist, andernfalls klicken Sie auf die Schaltfläche Nicht gefunden.",
                "amazon_music_profile": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie einen Künstler hinzufügen möchten, der bereits auf Amazon Music ist, andernfalls klicken Sie auf die Schaltfläche Nicht gefunden.",
                "apple_id": "Hinweis: Verwenden Sie dieses Feld nur, wenn Sie einen Künstler hinzufügen möchten, der bereits auf Apple Music ist, andernfalls klicken Sie auf die Schaltfläche Nicht gefunden."
            },
            "placeholder": {
                "spotify_profile": "Geben Sie den Künstlernamen ein, z.B. The Weekend oder die Spotify-ID des Künstlers, z.B. 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Geben Sie den Künstlernamen ein, z.B. The Weekend oder die Deezer-ID des Künstlers, z.B. 1406580",
                "amazon_music_profile": "Geben Sie den Künstlernamen ein, z.B. The Weekend oder die Amazon ASIN des Künstlers, z.B. B005GI0T2U",
                "apple_id": "Bitte geben Sie eine gültige Apple-ID ein. Beispiel: 635806095"
            },
            "button": {
                "reset": "Zurücksetzen",
                "not_found": "Nicht gefunden",
                "submit": "Absenden"
            },
            "validation": {
                "name_required": "Name ist erforderlich",
                "email_required": "E-Mail ist erforderlich",
                "email_invalid": "Bitte geben Sie eine gültige E-Mail ein",
                "name_duplicate": "Künstler existiert bereits",
                "name_mismatch": "Der Künstlername muss für alle Stores übereinstimmen",
                "name_mismatch_spotify": "Spotify-Profilname muss mit dem Künstlernamen übereinstimmen",
                "name_mismatch_deezer": "Deezer-Profilname muss mit dem Künstlernamen übereinstimmen",
                "name_mismatch_amazon_music": "Amazon-Profilname muss mit dem Künstlernamen übereinstimmen",
                "spotify_id_invalid": "Bitte fügen Sie eine gültige Spotify-ID hinzu. Beispiel: 6eUKZXaKkcviH0Ku9w2n3B. Weitere Informationen finden Sie in unserem Help Center.",
                "apple_id_required": "Apple-ID ist erforderlich",
                "apple_id_invalid": "Bitte fügen Sie eine gültige Apple-ID hinzu. Beispiel: 635806095. Weitere Informationen finden Sie in unserem Help Center."
            }
        },
        "modal": {
            "title": {
                "profile_reset_declaration": "Profil-Reset-Erklärung",
                "profile_not_present_declaration": "Profil nicht vorhanden Erklärung"
            },
            "body": {
                "profile_not_present_declaration": "Ich bestätige, dass das Profil dieses Künstlers auf <strong>{{store}}</strong> nicht vorhanden ist und dass das Profil dieses Künstlers neu auf <strong>{{store}}</strong> erstellt wird.",
                "profile_reset_declaration": "Ich bin mir bewusst, dass durch das Zurücksetzen des <strong>{{store}}</strong>-Profils dieses Künstlers die <strong>{{store}}-ID</strong> überall im System entfernt wird und es dadurch wahrscheinlich zu Störungen in den Stores und Künstlern kommen wird."
            },
            "button": {
                "confirm": "Bestätigen",
                "cancel": "Abbrechen"
            }
        },
        "message": {
            "success": "Künstler mit dem Namen '{{artistName}}' wurde aktualisiert!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "errorBlacklisted": "Eine oder mehrere der von Ihnen bereitgestellten Details sind mit einem gesperrten Künstler verbunden. Wenn Sie sicher sind, dass der Künstler nicht gesperrt ist, wenden Sie sich bitte an das Support-Team für weitere Informationen."
        }
    },
    "add_from_wishlist": {
        "title": "Künstler hinzufügen",
        "form": {
            "label": {
                "spotify_profile": "Spotify-Profil",
                "deezer_profile": "Deezer-Profil",
                "amazon_music_profile": "Amazon Music-Profil",
                "spotify_id": "Spotify-ID",
                "spotify_image": "Spotify-Bild",
                "deezer_id": "Deezer-ID",
                "deezer_image": "Deezer-Bild",
                "amazon_music_id": "Amazon-ID",
                "amazon_music_image": "Amazon Music-Bild",
                "apple_id": "Apple-ID",
                "apple_image": "Apple-Bild",
                "name": "Name",
                "name_preference": "Namenspräferenz",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "E-Mail",
                "subuser": "Sub-Benutzer"
            },
            "placeholder": {
                "spotify_profile": "Geben Sie den Künstlernamen ein, z.B. The Weekend oder die Spotify-ID des Künstlers, z.B. 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Geben Sie den Künstlernamen ein, z.B. The Weekend oder die Deezer-ID des Künstlers, z.B. 1406580",
                "amazon_music_profile": "Geben Sie den Künstlernamen ein, z.B. The Weekend oder die Amazon ASIN des Künstlers, z.B. B005GI0T2U",
                "apple_id": "Bitte geben Sie eine gültige Apple-ID ein. Beispiel: 635806095",
                "subuser": "Sub-Benutzer auswählen..."
            },
            "help_text": {
                "spotify_profile": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie einen Künstler hinzufügen möchten, der bereits auf Spotify ist, andernfalls klicken Sie auf die Schaltfläche Nicht gefunden.",
                "deezer_profile": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie einen Künstler hinzufügen möchten, der bereits auf Deezer ist, andernfalls klicken Sie auf die Schaltfläche Nicht gefunden.",
                "amazon_music_profile": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie einen Künstler hinzufügen möchten, der bereits auf Amazon Music ist, andernfalls klicken Sie auf die Schaltfläche Nicht gefunden.",
                "apple_id": "Hinweis: Verwenden Sie dieses Feld nur, wenn Sie einen Künstler hinzufügen möchten, der bereits auf Apple Music ist, andernfalls klicken Sie auf die Schaltfläche Nicht gefunden.",
                "subuser": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie einen Künstler für einen Ihrer Sub-Benutzer hinzufügen möchten, andernfalls lassen Sie es unselektiert."
            },
            "button": {
                "reset": "Zurücksetzen",
                "notFound": "Nicht gefunden?",
                "submit": "Absenden",
                "cancel": "Abbrechen",
                "confirm": "Bestätigen"
            },
            "validation": {
                "name_required": "Name ist erforderlich",
                "email_required": "E-Mail ist erforderlich",
                "email_invalid": "Bitte geben Sie eine gültige E-Mail ein",
                "spotify_id_invalid": "Bitte fügen Sie eine gültige Spotify-ID hinzu. Beispiel: 6eUKZXaKkcviH0Ku9w2n3B. Weitere Informationen finden Sie in unserem Help Center.",
                "apple_id_required": "Apple-ID ist erforderlich",
                "apple_id_invalid": "Bitte fügen Sie eine gültige Apple-ID hinzu. Beispiel: 635806095. Weitere Informationen finden Sie in unserem Help Center."
            },
            "message": {
                "errorArtistExists": "Künstler existiert bereits",
                "errorNameMismatch": "Der Künstlername muss für alle Stores übereinstimmen",
                "errorSpotifyNameMismatch": "Spotify-Profilname muss mit dem Künstlernamen übereinstimmen",
                "errorDeezerNameMismatch": "Deezer-Profilname muss mit dem Künstlernamen übereinstimmen",
                "errorAmazonNameMismatch": "Amazon-Profilname muss mit dem Künstlernamen übereinstimmen"
            }
        },
        "message": {
            "success": "Künstler wurde hinzugefügt!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "errorBlacklisted": "Eine oder mehrere der von Ihnen bereitgestellten Details sind mit einem gesperrten Künstler verbunden. Wenn Sie sicher sind, dass der Künstler nicht gesperrt ist, wenden Sie sich bitte an das Support-Team für weitere Informationen."
        },
        "modal": {
            "profileMissing": {
                "header": "Profil nicht vorhanden Erklärung",
                "body": "Ich bestätige, dass das Profil dieses Künstlers auf <strong>{{storeName}}</strong> nicht vorhanden ist und dass das Profil dieses Künstlers neu auf <strong>{{storeName}}</strong> erstellt wird.",
                "button": {
                    "cancel": "Abbrechen",
                    "confirm": "Bestätigen"
                }
            }
        }
    },
    "viewDetails": {
        "view": {
            "label": {
                "followers": "FOLLOWER",
                "popularity": "BELIEBTHEIT",
                "genres": "GENRES",
                "flagged": "MARKIERT",
                "notAvailable": "Nicht verfügbar",
                "notAvailableAbbr": "N/V"
            },
            "similarArtists": {
                "title": "Ähnliche Künstler",
                "table": {
                    "column": {
                        "artist": "Künstler",
                        "followers": "Follower",
                        "popularity_pct": "Beliebtheit (%)",
                        "genres": "Genres",
                        "wishlist": "Wunschliste"
                    }
                },
                "label": {
                    "notAvailable": "Nicht verfügbar",
                    "notAvailableAbbr": "N/V"
                },
                "message": {
                    "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
                },
                "modal": {
                    "addToWishlist": {
                        "header": "Künstler {{artistName}} zur Wunschliste hinzufügen",
                        "body": "Sind Sie sicher, dass Sie den Künstler {{artistName}} zu Ihrer Wunschliste hinzufügen möchten?",
                        "message": {
                            "success": "Künstler zur Wunschliste hinzugefügt!"
                        }
                    },
                    "removeFromWishlist": {
                        "header": "Künstler {{artistName}} von der Wunschliste entfernen",
                        "body": "Sind Sie sicher, dass Sie den Künstler {{artistName}} von Ihrer Wunschliste entfernen möchten?"
                    }
                }
            },
            "topTracks": {
                "title": "Top-Tracks",
                "table": {
                    "column": {
                        "track": "Track",
                        "release": "Veröffentlichung",
                        "artists": "Künstler",
                        "popularity_pct": "Beliebtheit (%)",
                        "preview": "Vorschau"
                    }
                },
                "label": {
                    "audioElementNotSupported": "Ihr Browser unterstützt das Audioelement nicht."
                }
            }
        }
    }
};

export default artistsDE;